/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SDDCStateEnum = 'DEPLOYING' | 'READY' | 'DELETING' | 'DELETED' | 'FAILED' | 'CANCELED' | 'READY_FOR_GLCM_BRINGUP';

export const SDDCStateEnum = {

    DEPLOYING: 'DEPLOYING' as SDDCStateEnum,

    READY: 'READY' as SDDCStateEnum,

    DELETING: 'DELETING' as SDDCStateEnum,

    DELETED: 'DELETED' as SDDCStateEnum,

    FAILED: 'FAILED' as SDDCStateEnum,

    CANCELED: 'CANCELED' as SDDCStateEnum,

    READY_FOR_GLCM_BRINGUP: 'READY_FOR_GLCM_BRINGUP' as SDDCStateEnum
};

